import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { TagStateContext, type UpdateTagParams } from '../Context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

export const useUpdateProjectTagMutation = (projectId: number) => {
  const { dispatch } = useContext(TagStateContext);
  const queryClient = useQueryClient();

  const apiClient = useChatApiClient();

  return useMutation({
    mutationFn: ({ tagId, ...updates }: UpdateTagParams) => {
      return apiClient.projects.updateProjectTag({
        projectId,
        tagId,
        updates,
      });
    },
    onSuccess: (res, params) => {
      // Invalidate tags query to refresh the table data
      dispatch({
        type: 'update-tag',
        projectTagId: params.tagId,
        partialTag: {
          includeSummary: params.includeSummary,
          hidden: params.hidden,
        },
        baseTag: { name: params.title, color: params.color },
      });
      queryClient.invalidateQueries({
        queryKey: ['get:projects/tags', projectId],
      });
    },
    onError: (error) => {
      console.error('Error updating project tag:', error);
    },
  });
};